import Transfer from './Transfer';

export default Transfer;



// WEBPACK FOOTER //
// ./foody/src/pages/Transfer/index.js